import React from "react";

type SettingsPanelActionsProps = {
  children: React.ReactNode;
};

/** Search / sort / primary actions row inside a settings tab panel. */
export function SettingsPanelActions({ children }: SettingsPanelActionsProps) {
  return (
    <div className="sa-settings-panel__actions" role="toolbar" aria-label="List actions">
      {children}
    </div>
  );
}

export default SettingsPanelActions;
